import { Injectable } from '@angular/core';
import { CostAccountingRequestService } from '../services/cost-accounting-request.request.service';
import { Observable } from 'rxjs';
import { IReference } from '../models/reference.model';

const BASE_URL: string = 'reference';

@Injectable({
    providedIn: 'root'
})
export class ReferenceResource {
    constructor(private myCostAccountingRequestService: CostAccountingRequestService) {
    }

    public getAllReferences(): Observable<IReference[]> {
        return this.myCostAccountingRequestService.get(BASE_URL);
    }

    public createReference(reference: IReference): Observable<IReference> {
        return this.myCostAccountingRequestService.post(BASE_URL, reference);
    }

    public updateReference(reference: IReference): Observable<IReference> {
        return this.myCostAccountingRequestService.put(`${BASE_URL}/${reference.id}`, reference);
    }

    public deleteReference(referenceId: number): Observable<void> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${referenceId}`);
    }
}
